// Lib
import React from 'react';
import { useTranslator } from '../../components/i18n/useTranslator';

// Components
import FullScreenErrorModal from '../../components/modal/FullScreenErrorModal';
import ModalActionsList from '../../components/modal/ModalActionsList';

const PlatformCookieFullScreenWarning = () => {
    const translate = useTranslator('modal', 'platform.cookies');

    return (
        <FullScreenErrorModal>
            <h2>{translate('title', 'Sorry, you need to enable storage to use Milanote')}</h2>
            <p className="explanation">
                {translate('description', 'Milanote uses your browser\'s storage to save data while you\'re working, please enable it and try again.')}
            </p>
            <ModalActionsList actions={[{ text: translate('findOutMoreLink', 'Find out more'), href: 'http://www.whatarecookies.com/' }]} />
        </FullScreenErrorModal>
    );
};

PlatformCookieFullScreenWarning.propTypes = {};

export default PlatformCookieFullScreenWarning;
